import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ICertificadoInfoDTO } from '../dto/certificado-info.dto';

@Injectable({
  providedIn: 'root'
})
export class CertificadoService {

  private urlEndPointGeneral = environment.urlEndPoint.concat('/general/certificado');
  private urlEndPointAutenticado = environment.urlEndPoint.concat('/autenticado/certificado');

  constructor(private httpClient: HttpClient) { }

  public visualizarCertificadoGenerado(cerCodigo: string): Observable<HttpResponse<ICertificadoInfoDTO>>{
    return this.httpClient.get<ICertificadoInfoDTO>(`${this.urlEndPointAutenticado}/visualizar-certificado-generado`, { params: { cerCodigo }, observe: 'response' });
  }

  public obtenerCertificadoGenerado(strCodificado: string): Observable<HttpResponse<ICertificadoInfoDTO>>{
    console.log('strCodificado');
    console.log(strCodificado);
    return this.httpClient.get<ICertificadoInfoDTO>(`${this.urlEndPointGeneral}/obtener-certificado-generado`, { params: { strCodificado }, observe: 'response' });
  }

}
